export const GENERIC_ERROR_MESSAGE = 'Something went wrong, please try again later';

/** Text for an error toast: the Error's message when there is one, otherwise the generic sentence. */
export const errorMessage = (error: unknown, fallback: string = GENERIC_ERROR_MESSAGE): string =>
    error instanceof Error && error.message ? error.message : fallback;
